import { useOptimizedRecords } from '@/shared/hooks/useOptimizedQuery'

import type { ContentHistoryEntry, PaginationMeta } from '../types'

interface UseContentHistoryParams {
  page: number
  perPage?: number
  // Um ou mais tipos: a opção "Passe" do filtro cobre dois resource_type
  // (recompensa de conclusão e missão do passe), e a API aceita array.
  resourceType?: string | readonly string[]
  name?: string
}

/**
 * Histórico de conclusão de conteúdo do próprio aluno (self), paginado e
 * filtrável por tipo e nome/título. Desafios não entram na timeline (a API os
 * exclui) — sua conclusão é vista pelo modal de detalhe do nível.
 */
export function useContentHistory({
  page,
  perPage = 10,
  resourceType,
  name
}: UseContentHistoryParams) {
  const types = resourceType == null ? [] : [resourceType].flat()

  const query = useOptimizedRecords<ContentHistoryEntry>({
    path: '/user/content_history',
    params: {
      page,
      per_page: perPage,
      ...(types.length ? { resource_type: types } : {}),
      ...(name ? { name } : {})
    },
    usePlaceholder: true
  })

  return {
    ...query,
    records: query.records as ContentHistoryEntry[],
    pagination: query.pagination as PaginationMeta | undefined
  }
}
